const dateFormat = 'MM/dd/yyyy';

export default dateFormat;
